var map = {
	"./ApeCoin.png": 8565,
	"./BERACHAIN.png": 2197,
	"./BNBChain.png": 4473,
	"./Base.png": 4175,
	"./SOLANA.png": 7716,
	"./SUI.png": 8363,
	"./TRON.png": 1373,
	"./XRP.png": 4816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2835;